<template>
  <div class="kt-portlet__foot py-3 sticky-bottom" id="portletFoot">
    <div class="row align-items-center">
      <div class="col-lg-6 kt-valign-middle">
        <slot name="leftButtons" />
      </div>
      <div class="col-lg-6 kt-align-right">
        <slot name="rightButtons"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabbedPortletFoot'
}
</script>

<style lang="scss" scoped>
.sticky-bottom {
  position: sticky !important;
  bottom: 0;
  background: white;
}
</style>
